// extracted by mini-css-extract-plugin
export var cardLayout = "_7y-1";
export var paginationContainer = "_7y-0";